module.exports = __webpack_public_path__ + "img/profile_box_gray_special_skill.1bfee243.svg";